import type { Identifier } from "ra-core";
import { useGetManyReference } from "ra-core";

export const useContactTimelineCount = (
  contactId?: Identifier,
  options?: { enabled?: boolean },
) => {
  const enabled = options?.enabled ?? contactId != null;

  const { total: notesTotal = 0 } = useGetManyReference(
    "contact_notes",
    {
      target: "contact_id",
      id: contactId!,
      pagination: { page: 1, perPage: 1 },
    },
    { enabled },
  );

  const { total: interactionsTotal = 0 } = useGetManyReference(
    "bc_interaction_log",
    {
      target: "contact_id",
      id: contactId!,
      pagination: { page: 1, perPage: 1 },
    },
    { enabled },
  );

  return notesTotal + interactionsTotal;
};
